import React, { useCallback } from 'react';
import styled, { css } from 'styled-components';
import { SelectOption } from 'component-library-and-tools';
import { useDispatch } from 'react-redux';

import Button from 'shared/components/Button';
import LabeledContent from 'shared/components/LabeledContent';
import SearchBar from 'shared/components/SearchBar';
import Select from 'shared/components/Select';
import { openModal } from 'services/modal/actions';

import { SAFELIST_TERM_MANAGER_MODAL } from '../../../SafelistTermManager';

import { SELECT_TYPE_OPTIONS, SEARCH_FILTER_KEY, TERM_TYPE_KEY } from '../../../constants';
import { SafelistTermListHeaderProps } from './types';

const commonStyles = css`
  height: 3.67rem;
`;

const StyledSafelistTermListHeaderContainer = styled.div`
  display: flex;
  align-items: flex-end;
  margin-bottom: 1.3rem;
`;

const StyledFilterContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: flex-end;
  margin-right: 2rem;

  & > *:not(:last-child) {
    margin-right: 1rem;
  }
`;

const StyledLabeledContent = styled(LabeledContent)`
  flex: 1;
`;

const StyledSearchBar = styled(SearchBar)`
  ${commonStyles}
  flex-basis: 59.54%;
`;

const StyledTypeSelect = styled(Select)`
  ${commonStyles}
  flex-basis: 12.16%;
`;

const StyledButton = styled(Button)`
  && {
    ${commonStyles}
    flex-basis: 11.8%;
    background-color: #d7dae0;
    color: #33373d;
    font-weight: 700;
  }
`;

// TODO: This is temporary until we abstract it to a reusable component.
const SafelistTermListHeader = ({
  className,
  filters,
  onFilterChange = () => {},
}: SafelistTermListHeaderProps) => {
  const dispatch = useDispatch();

  const onAddItemsClick = useCallback(() => {
    dispatch(openModal(SAFELIST_TERM_MANAGER_MODAL))
  }, []);

  // TODO: Specify args!
  const handleFilterChange = (filterKey: string, filterValue: any) => {
    const updatedFilters = {
      ...filters,
      [filterKey]: filterValue,
    };

    onFilterChange(updatedFilters);
  };

  return (
    <StyledSafelistTermListHeaderContainer className={className}>
      <StyledFilterContainer>
        <StyledLabeledContent label='Safelist Items'>
          <StyledSearchBar
            delayToSearch={250}
            onSearch={(searchValue) => handleFilterChange(SEARCH_FILTER_KEY, searchValue)}
          />
        </StyledLabeledContent>
        <StyledTypeSelect
          isMultiSelect
          allSelectedLabel='Type: All'
          menuGap={4}
          options={SELECT_TYPE_OPTIONS}
          onSelect={(selectedOptions) => handleFilterChange(TERM_TYPE_KEY, (selectedOptions as SelectOption[]).map((so) => so.name))}
        />
      </StyledFilterContainer>
      <StyledButton label='Add Items' onClick={onAddItemsClick} />
    </StyledSafelistTermListHeaderContainer>
  );
};

export { SafelistTermListHeader };
